module.exports = __webpack_public_path__ + "img/contact.fa022671.svg";